export default function smoothScroll(elementToScroll, target, options = {}) {
  const
    opt = {
      callback: options.callback,
    },
    duration = 400;

  let
    startX,
    startY,
    distanceX,
    distanceY,
    timeStart,
    timeElapsed;

  if (elementToScroll == window) {
    startX = elementToScroll.pageXOffset;
    startY = elementToScroll.pageYOffset;
    distanceX = target.getBoundingClientRect().left;
    distanceY =
      target.getBoundingClientRect().top -
      document.querySelector('.tab-header').offsetHeight;
  }
  else {
    startX = elementToScroll.scrollLeft;
    startY = elementToScroll.scrollTop;

    const
      elementToScrollDomRect = elementToScroll.getBoundingClientRect(),
      targetDomRect = target.getBoundingClientRect();

    distanceX = targetDomRect.left - elementToScrollDomRect.left;
    distanceY = targetDomRect.top - elementToScrollDomRect.top;
  }

  // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
  function easeInOutQuad (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  function end () {
    elementToScroll.scrollTo(startX + distanceX, startY + distanceY);

    if (typeof opt.callback === "function") {
      opt.callback();
    }
  }

  function loop (time) {
    timeElapsed = time - timeStart;

    elementToScroll.scrollTo(easeInOutQuad(timeElapsed, startX, distanceX, duration), easeInOutQuad(timeElapsed, startY, distanceY, duration));

    if (timeElapsed < duration) {
      requestAnimationFrame(loop);
    }
    else {
      end();
    }
  }

  requestAnimationFrame(function (time) {
    timeStart = time;
    loop(time);
  });
}
